<template>
  <Layout footer>
    <div class="app-container">
      <div
        class="flex items-center py-5 text-base border-b border-gray-300"
        style="background-color: #faf9f9"
      >
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>学习中心</NBreadcrumbItem>
          <NBreadcrumbItem>线下学习</NBreadcrumbItem>
        </NBreadcrumb>
      </div>

      <n-form :label-width="80" :model="formValue" size="large" label-placement="left" class="mb-8">
        <div class="flex items-center mt-6 space-x-10">
          <n-form-item label="开课日期：">
            <n-date-picker v-model:value="formValue.beginTime" type="date" clearable />
          </n-form-item>
          <!--          <n-form-item label="结课日期：">-->
          <!--            <n-date-picker v-model:value="formValue.endTime" type="date" clearable />-->
          <!--          </n-form-item>-->
          <!--          <n-button text>-->
          <!--            <span class="underline text-base">近七天开课</span>-->
          <!--          </n-button>-->
          <!--          <n-button text>-->
          <!--            <span class="underline text-base">近一个月内开课</span>-->
          <!--          </n-button>-->
          <!--          <n-button text>-->
          <!--            <span class="underline text-base">近三个月内开课</span>-->
          <!--          </n-button>-->
          <n-button size="large" type="primary" style="margin-left: 16px">搜索</n-button>
        </div>
        <div class="flex items-center mt-6 space-x-10">
          <!--          <n-form-item label="课程名称：">-->
          <!--            <n-input-->
          <!--              style="width: 220px"-->
          <!--              v-model:value="formValue.className"-->
          <!--              placeholder="请输入课程名称"-->
          <!--            />-->
          <!--          </n-form-item>-->
          <!--          <n-form-item label="机构名称：">-->
          <!--            <n-input-->
          <!--              style="width: 220px"-->
          <!--              v-model:value="formValue.organizationName"-->
          <!--              placeholder="请输入机构名称："-->
          <!--            />-->
          <!--          </n-form-item>-->
          <!--          <n-form-item label="开课区域：">-->
          <!--            <n-input v-model:value="formValue.region" placeholder="请输入机构名称：" />-->
          <!--          </n-form-item>-->
          <!--          <n-button size="large" type="primary" style="margin-left: 16px">搜索</n-button>-->
        </div>
      </n-form>

      <div class="relative px-7 py-5 border border-gray-300">
        <NSpin :show="initLoading" :class="{ 'py-40': initLoading }">
          <NEmpty
            class="py-32"
            description="暂无数据"
            v-if="!initLoading && classList.length === 0"
          />
          <div
            v-for="(group, groupIndex) in classList"
            :key="group.id"
            :class="{ 'mt-8': groupIndex > 0 }"
            v-show="!initLoading && classList.length > 0"
          >
            <n-button ghost style="border-radius: 8px" type="primary" class="absolute right-7">
              {{ group.state === 1 ? '待上课' : group.state === 2 ? '上课中' : '完成' }}
            </n-button>
            <div class="w-4/5">
              <div class="header flex items-center justify-between">
                <span class="text-lg">{{ group.lineClassCourseName }}</span>
                <div class="text-gray-400 text-base">
                  <span>{{ group.headTeacherName }}</span>
                  <span class="ml-6">{{ group.credit }} 课时</span>
                </div>
              </div>
              <div class="mt-4 text-base"> 上课时间：{{ group.classTime }}</div>
              <div class="mt-2 text-base">
                上课地点：{{ group.addressName }}
                <span class="ml-4" style="color: #ea4c00">开课机构：{{ group.tenantName }}</span>
              </div>
            </div>
            <!--            <div class="flex justify-end h-6">-->
            <!--              <n-icon size="40" color="#a9a8a8" class="-mr-2 cursor-pointer transform">-->
            <!--                <svg-->
            <!--                  xmlns="http://www.w3.org/2000/svg"-->
            <!--                  xmlns:xlink="http://www.w3.org/1999/xlink"-->
            <!--                  viewBox="0 0 24 24"-->
            <!--                  class="-mt-2"-->
            <!--                >-->
            <!--                  <path-->
            <!--                    d="M8.71 11.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71z"-->
            <!--                    fill="currentColor"-->
            <!--                  ></path>-->
            <!--                </svg>-->
            <!--              </n-icon>-->
            <!--            </div>-->
            <!--            课程列表 详情 开始-->
            <div class="mt-14">
              <!--              老版-->
              <!--              <div-->
              <!--                class="flex items-center px-5 py-3 text-base border-b border-gray-300"-->
              <!--                v-for="(item, index) in group.classPeriodVOList"-->
              <!--                :key="item.item"-->
              <!--              >-->
              <!--                {{ index + 1 }}、-->
              <!--                <span>{{ item.classTime }}</span>-->
              <!--                <span class="mx-2">{{ item.modeName }}</span>-->
              <!--                <span>讲师 ：{{ item.lecturerName }}</span>-->
              <!--                <n-button-->
              <!--                  ghost-->
              <!--                  :type="item.isSignIn === 1 ? 'success' : 'primary'"-->
              <!--                  size="small"-->
              <!--                  class="ml-auto"-->
              <!--                >-->
              <!--                  {{ item.isSignIn === 1 ? '已签到' : '未签到' }}-->
              <!--                </n-button>-->
              <!--              </div>-->
              <!--              老版-->

              <!--              新版-->
              <div class="mt-5">
                <NCollapse default-expanded-names="1" accordion>
                  <NCollapseItem
                    :title="
                      group.lineClassCourseName +
                      '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上课地点: ' +
                      group.addressName +
                      '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp上课时间: ' +
                      group.classTime
                    "
                    name="1"
                  >
                    <template #header-extra
                      ><n-button
                        ghost
                        style="border-radius: 8px"
                        type="success"
                        class="absolute right-7"
                      >
                        {{ group.state === 1 ? '待上课' : group.state === 2 ? '上课中' : '完成' }}
                      </n-button></template
                    >
                    <div
                      class="flex items-center px-5 py-3 text-base border-b border-gray-300"
                      v-for="(item, index) in group.classPeriodVOList"
                      :key="item.item"
                    >
                      {{ index + 1 }}、
                      <span>{{ item.classTime }}</span>
                      <span class="mx-2">{{ item.modeName }}</span>
                      <span>讲师 ：{{ item.lecturerName }}</span>
                      <n-button
                        ghost
                        :type="item.isSignIn === 1 ? 'success' : 'primary'"
                        size="small"
                        class="ml-auto"
                      >
                        {{ item.isSignIn === 1 ? '已签到' : '未签到' }}
                      </n-button>
                    </div>
                  </NCollapseItem>
                </NCollapse>
                <div style="height: 50px" class="border-b border-gray-300"></div>
              </div>
              <!--              新版-->
            </div>
            <!--            课程列表 详情 结束-->
          </div>
        </NSpin>
      </div>
    </div>
  </Layout>
</template>

<script setup>
import { NCollapse, NCollapseItem } from 'naive-ui';
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Layout from '@/components/Layout';
import { getClassInfoByDateApi } from '@/api';

const router = useRouter();

function gotoHome() {
  router.push('/');
}

const formValue = reactive({
  beginTime: null,
  endTime: null,
  className: '',
  organizationName: '',
  region: '',
});
const classList = ref([]);
const initLoading = ref(true);
getClassInfoByDateApi()
  .then(res => {
    res = res.data;
    const data = res.records;
    classList.value = data;
  })
  .finally(() => (initLoading.value = false));
</script>

<style lang="scss" scoped>
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}

:deep(.n-form-item-feedback-wrapper) {
  display: none;
}

.text-24 {
  font-size: 24px;
}

.text-26 {
  font-size: 26px;
}
</style>
